import { useMemo } from 'react';
import { useAuth } from '#/hooks/useAuth';
import getJucyRentalsApiClient, { JucyRentalsApiClient } from '../lib/getJucyRentalsApiClient';

export const useRentalsApi = (): JucyRentalsApiClient => {
    const { user } = useAuth();
    return useMemo(() => getJucyRentalsApiClient({ user }), [user]);
};
